import { TOGGLE_MODAL, TagBrowserReducerState, ADD_NEW_SYNC_SET_INFO } from './types';

export const toggleTagBrowserModal = (modalType: keyof TagBrowserReducerState['showModal'], action: boolean) =>
    ({ type: TOGGLE_MODAL, payload: {[modalType]: action } });

export const addNewSyncSetInfo = (payload: TagBrowserReducerState['newSyncSetInfo']) =>
    ({ type: ADD_NEW_SYNC_SET_INFO, payload });